// Customers (CRM): list + detail. French string → English.
const m: Record<string, string> = {
  'Clients': 'Customers',
  'Vos meilleurs clients — valeur à vie et profit': 'Your best customers — lifetime value and profit',
  'clients uniques (par téléphone)': 'unique customers (by phone)',
  'Taux de fidélité': 'Repeat rate',
  '{n} acheteurs récurrents': '{n} repeat buyers',
  'Valeur à vie moyenne': 'Average lifetime value',
  'revenu moyen par client': 'average revenue per customer',
  'Rechercher par nom ou téléphone…': 'Search by name or phone…',
  'Trier par': 'Sort by',
  'Revenu à vie': 'Lifetime revenue',
  'Profit net': 'Net profit',
  'Acheteurs récurrents uniquement': 'Repeat buyers only',
  'Toutes les sources': 'All sources',
  'Chargement…': 'Loading…',
  'Client': 'Customer',
  'Source': 'Source',
  'Cmd.': 'Orders',
  'Dernière commande': 'Last order',
  'Aucun client': 'No customers',
  'Fidèle': 'Repeat',
  '{n} commandes': '{n} orders',
  '{n} clients affichés': '{n} customers shown',
  'Réinitialiser les filtres': 'Reset filters',

  // ─── Detail / profile page ───────────────────────────────────────────────
  'Fiche client': 'Customer profile',
  'Client introuvable': 'Customer not found',
  'Client depuis': 'Customer since',
  'Commandes': 'Orders',
  'Aussi connu sous:': 'Also known as:',
  // Money panel
  'Panier moyen': 'Average order value',
  'par commande': 'per order',
  'Coût des marchandises (à vie)': 'Lifetime COGS',
  'Contribution (à vie)': 'Lifetime contribution',
  'Coût pub (à vie)': 'Lifetime ad cost',
  'Coût d’acquisition (1ʳᵉ commande)': 'Acquisition cost (1st order)',
  'LTV vs CAC': 'LTV vs CAC',
  'Coût pub non configuré': 'Ad cost not configured',
  // Order history
  'Historique des commandes': 'Order history',
  'Aucune commande': 'No orders',
  'Destination(s)': 'Destination(s)',
  'Pages': 'Pages',
  'pages': 'pages',
  'Coupon': 'Coupon',
  'suivi prochainement': 'tracked soon',
  'Livraison estimée': 'Estimated delivery',
  'Contribution': 'Contribution',
  'Coût pub': 'Ad cost',
  // AMEEX statuses
  'En attente': 'Pending',
  'En cours': 'In progress',
  'En distribution': 'Out for delivery',
  'Livré': 'Delivered',
  'Reporté': 'Postponed',
  'Retourné': 'Returned',
  'Refusé': 'Refused',
  'Annulé': 'Cancelled',
  'Remboursé': 'Refunded',
  'Non résolu': 'Unresolved',
  'Pas de suivi': 'No tracking',
  // Coupons section
  'Coupons utilisés': 'Coupons used',
  'Bientôt disponible': 'Coming soon',
  'Les coupons seront suivis prochainement.': 'Coupons will be tracked soon.',
  // Notes
  'Notes internes': 'Internal notes',
  'Ajoutez des notes sur ce client (préférences, historique, rappels…)':
    'Add notes about this customer (preferences, history, reminders…)',
  'Modifié le {date} par {who}': 'Edited on {date} by {who}',
  'Aucune note enregistrée': 'No notes saved',
  'inconnu': 'unknown',
  'Enregistrer': 'Save',
  'Voir la commande': 'View order',
};

export default m;
